"use strict";

require("init");

require("semantic-ui-css");
require('datatables.net');
require('datatables.net-se');
require('commonAdmin');

$(document).ready
(
    function()
    {
        $('.message .close')
        .on('click',
            function()
            {
                $(this)
                .closest('.message')
                .transition('fade');
            }
        );

        $('.ui.dropdown').dropdown();
        $('*[data-content], *[data-tooltip]').popup();

        $('.popup.button').each
        (
            function()
            {
                $(this).popup
                (
                    {
                        popup: $('.popup.consistValue[data-id=' + $(this).attr("data-id") + ']'),
                        on: 'hover',
                        inline: true,
                        onHidden: function()
                        {
                            $(this).removeClass("hidden");
                        }
                    }
                );
            }
        );
    }
);
